import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { notify } from 'components/Notifier';
import { ReportType } from 'enums/reports';
import {
  downloadAllReports,
  downloadClientMonthlyResultReport,
  downloadCumulatedMonhlyReport,
  downloadGlobalReportDistributionKeys,
  downloadGlobalReportMaterialResults,
  downloadGlobalReportProductionExpedition,
  downloadGlobalReportTheoreticalAndRealised,
  downloadStocksAmontsFinauxReport,
} from 'services/apiOperations';
import { Closure } from 'types';

export const useHandleClickDownloadReport = (
  sortingCenterId: string | null,
  closure: Closure | null,
  isPreview: boolean,
) => {
  const { t } = useTranslation();

  return useCallback(
    (reportType: ReportType, id?: number) => {
      if (!sortingCenterId || !closure) return;

      switch (reportType) {
        case ReportType.ALL:
          downloadAllReports(sortingCenterId, closure.year.toString(), closure.month.toString(), isPreview);
          break;
        case ReportType.GLOBAL_THEORETICAL_AND_REALISED:
          downloadGlobalReportTheoreticalAndRealised(
            sortingCenterId,
            closure.year.toString(),
            closure.month.toString(),
            isPreview,
          );
          break;
        case ReportType.GLOBAL_REPORT_RESULT_AND_MATERIAL:
          downloadGlobalReportMaterialResults(
            sortingCenterId,
            closure.year.toString(),
            closure.month.toString(),
            isPreview,
          );
          break;
        case ReportType.GLOBAL_PRODUCTION_AND_EXPEDITION:
          const startDate = new Date(closure.year, closure.month, 0);
          const endDate = new Date(closure.year, closure.month, 0);
          downloadGlobalReportProductionExpedition(sortingCenterId, startDate, endDate, isPreview);
          break;
        case ReportType.CUMULATED_MONTHLY_REPORT_EXPORTER:
          downloadCumulatedMonhlyReport(sortingCenterId, closure.year.toString(), closure.month.toString(), isPreview);
          break;
        case ReportType.STOCKS_AMONTS_FINAUX:
          downloadStocksAmontsFinauxReport(
            sortingCenterId,
            closure.year.toString(),
            closure.month.toString(),
            isPreview,
          );
          break;
        case ReportType.DISTRIBUTION_KEYS:
          downloadGlobalReportDistributionKeys(
            sortingCenterId,
            closure.year.toString(),
            closure.month.toString(),
            isPreview,
          );
          break;
        case ReportType.CLIENT:
          if (!id) {
            notify({
              message: t('reports.download.error'),
              severity: 'error',
            });
            break;
          }

          downloadClientMonthlyResultReport(
            sortingCenterId,
            closure.year.toString(),
            closure.month.toString(),
            id,
            isPreview,
          );
          break;
      }
    },
    [sortingCenterId, closure, isPreview, t],
  );
};
